import { useContentSelectieContext } from "@/context/ContentSelectieContext";
import ProfielSelectV2 from "./ProfielSelectV2";
import ModusSelectV2 from "./modusselect/ModusSelectV2";
import QuickstartModusSelect from "./modusselect/QuickstartModusSelect";
import type { ContentSelectFlow } from "./types";

export default function ContentSelectV2({
  hideTitle = false,
  hideBreadcrumbs = false,
  flow = "full"
}: {
  hideTitle?: boolean;
  hideBreadcrumbs?: boolean;
  flow?: ContentSelectFlow;
}) {
  const { phase } = useContentSelectieContext();

  return (
    <div className="mx-auto transition-all duration-300 ease-in-out max-w-3xl">
      {phase === "profiel" && (
        <ProfielSelectV2
          hideTitle={hideTitle}
          hideBreadcrumbs={hideBreadcrumbs}
          flow={flow}
        />
      )}
      {phase === "modus" &&
        (flow === "quickstart" ? (
          <QuickstartModusSelect
            hideTitle={hideTitle}
            hideBreadcrumbs={hideBreadcrumbs}
          />
        ) : (
          <ModusSelectV2
            hideTitle={hideTitle}
            hideBreadcrumbs={hideBreadcrumbs}
          />
        ))}
    </div>
  );
}
